/**
 * @generated SignedSource<<2f65c0b97f042fcc6664808cb38b2c3c>>
 * @relayHash ec786244fafaad0889214a67518bc13b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec786244fafaad0889214a67518bc13b

import { ConcreteRequest } from 'relay-runtime';
export type useChIsPatientInDataGuardQuery$variables = {
  patientId: string;
};
export type useChIsPatientInDataGuardQuery$data = {
  readonly ch_isPatientInDataGuard: boolean;
};
export type useChIsPatientInDataGuardQuery = {
  response: useChIsPatientInDataGuardQuery$data;
  variables: useChIsPatientInDataGuardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "kind": "ScalarField",
    "name": "ch_isPatientInDataGuard",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChIsPatientInDataGuardQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChIsPatientInDataGuardQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ec786244fafaad0889214a67518bc13b",
    "metadata": {},
    "name": "useChIsPatientInDataGuardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9223fafeb1df531645947ab28b93bc13";

export default node;
